const pxToRem = (px: number): number => px / 16;

const rem = (rem: number): string => `${rem}rem`;

const px = (px: number): string => `${px}px`;

const percentage = (value: number): string => `${value}%`;

export { pxToRem, rem, px, percentage };
